import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://anhsumvnxmxosdjclfss.supabase.co';
const supabaseKey = 'sb_publishable_zCbphYfUBkASf3_Zjnp04w_VZJGGH8c';

export const supabase = createClient(supabaseUrl, supabaseKey);
